module.exports = __webpack_public_path__ + "media/customizations/shellstonelife/back-2f17df853ca3c7b0a8e46bbdb50f360e.jpg";